import { Link } from "react-router-dom";

export default function Success() {
  return (
    <section className="min-h-[60vh] flex flex-col items-center justify-center px-6 py-12 text-center">
      <h1 className="text-3xl font-bold mb-4 text-green-600">✅ Merci pour votre commande !</h1>
      <p className="text-gray-600 mb-6">
        Votre paiement a été traité avec succès. Vous recevrez bientôt une confirmation par email.
      </p>
      <Link
        to="/articles"
        className="bg-black text-white px-6 py-2 rounded hover:bg-gray-800 transition"
      >
        Continuer vos achats
      </Link>
    </section>
  );
}
